import _ from 'lodashParts'
const defaultEventHandler = set => () => {
    set.forEach(listener => {
        listener()
    })
}

const innerEventDefaultHandler = set => (...args) => {
    set.forEach(listener => {
        listener(...args)
    })
}

const handleExternalPaste = set => e => {
    var dataToPass = {
        data: {
            pasteString: e.data.pasteString,
            isExternalSourceData: e.data.isExternalSourceData
        }
    }
    set.forEach(listener => {
        listener(dataToPass)
    })
    e.data.pasteString = dataToPass.data.pasteString
}

const handleDataChanged = (set, mainController) => {
    let lastData
    return _.debounce(() => {
        const data = mainController.getData()
        if (!_.isEqual(lastData, data)) {
            lastData = data
            set.forEach(listener => {
                listener(data)
            })
        }
    }, 1)
}

const handleKeyEvent = set => e => {
    set.forEach(listener => {
        listener(e.data.domEvent.$)
    })
}
function init(privates) {
    privates.innerSelectionChangeListeners = new Set()
    initializeEvents.call(this, privates)
    initInnerListeners.call(this, privates)
}

function initializeEvents(privates) {
    const {engineAdapter, innerSelectionChangeListeners} = privates
    const events = {
        onDataChange: {listenToEvent: 'change', handle: handleDataChanged},
        onCut: {listenToEvent: 'cut', handle: defaultEventHandler},
        onCopy: {listenToEvent: 'copy', handle: defaultEventHandler},
        onBlur: {listenToEvent: 'blur', handle: defaultEventHandler},
        onFocus: {listenToEvent: 'focus', handle: defaultEventHandler},
        onAfterUndo: {listenToEvent: 'undo.afterUndo', handle: defaultEventHandler},
        onAfterRedo: {listenToEvent: 'redo.afterRedo', handle: defaultEventHandler},
        onExternalPasteHandle: {listenToEvent: 'externalPasteHandle', handle: handleExternalPaste},
        onKey: {listenToEvent: 'key', handle: handleKeyEvent},
        onCmdStateChange: {handle: innerEventDefaultHandler}
    }
    _.forEach(events, (val, key) => {
        val.set = new Set()
        val.handle = val.handle(val.set, this)
        this[key] = listener => {
            if (typeof listener === 'function') {
                val.set.add(listener)
            }
        }
        if (val.listenToEvent) {
            innerSelectionChangeListeners.add(engineAdapter.on(val.listenToEvent, val.handle))
        }
    })
    const unRegisterAllListeners = () => {
        innerSelectionChangeListeners.forEach(eventListener => {
            engineAdapter.removeListener(eventListener)
        })
        innerSelectionChangeListeners.clear()
        _.forEach(events, cmd => cmd.set.clear())
    }
    const unRegisterListener = listener => {
        innerSelectionChangeListeners.delete(listener)
        _.forEach(events, cmd => {
            cmd.set.delete(listener)
        })
    }
    const fire = (evtName, ...args) => {
        if (events[evtName]) {
            events[evtName].handle(...args)
        }
    }

    _.assign(privates, {
        unRegisterAllListeners,
        unRegisterListener,
        fire
    })
}
function initInnerListeners(privates) {
    const {engineAdapter, innerSelectionChangeListeners} = privates
    this.onExternalPasteHandle(privates.handlePaste)
    innerSelectionChangeListeners.add(engineAdapter.on('selectionChange', privates.handleSelectionChanged))
    innerSelectionChangeListeners.add(engineAdapter.on('selectionCheck', privates.generateSelectionChangeHandler(['wixLink'])))
}

module.exports = {init}



// WEBPACK FOOTER //
// ./src/mainController/mainControllerEvents.js